import { t } from "i18next";
import * as React from "react";
import { onError } from "src/common/onError";
import { EntityEditorModal } from "src/components/EntityEditor";
import { EntityCardStore } from "src/pages/EntityCardPage/EntityCardStore";
import { ZBom3 } from "../ZBom3";

type PropsBom3EditModal = {
  currentBom: ZBom3 | null;
  close: () => void;
  onSuccess: () => void;
};

export const Bom3EditModal: React.FC<PropsBom3EditModal> = (props) => {
  const { currentBom, close, onSuccess } = props;
  const [store, setStore] = React.useState<EntityCardStore | null>(null);

  React.useEffect(() => {
    if (currentBom) {
      try {
        const newStore = new EntityCardStore({});
        newStore.init(currentBom.id);
        setStore(newStore);
      } catch (e) {
        onError(e);
        setStore(null);
        close();
      }
    } else {
      setStore(null);
    }
  }, [currentBom?.id]);

  return (
    <EntityEditorModal
      store={store}
      modalProps={{
        open: !!currentBom,
        onCancel: close,
      }}
      editorProps={{
        submitText: t("Apply"),
        onSuccess,
      }}
    />
  );
};
